/**
 * Check if the value is filled with a valid value.
 * For example, undefined or null will not be considered as filled
 *
 * Motivation: zero (0) is considered as false in v-if condition
 * @param {*} value
 * @returns {boolean}
 */
const filled = (value) => {
  return typeof value !== typeof undefined && value !== null;
};

// https://dev.to/zirkelc/symmetric-difference-of-arrays-in-javascript-224f
// diff between two arrays (xor), finds keys not included in both arrays
// ie. arr1: [a, b, c, f],
//     arr2: [a, b, d, e]
//     result: [c, f, d, e]
const symmetricDifference = (arrayA, arrayB) => {
  const setA = new Set(arrayA);
  const setB = new Set(arrayB);

  const diffA = Array.from(setA).filter((x) => !setB.has(x));
  const diffB = Array.from(setB).filter((x) => !setA.has(x));

  return [...diffA, ...diffB];
};

export { filled, symmetricDifference };
